import { Component, Input } from '@angular/core';

@Component({
  selector: 'tracker-admin-workflow-transition-tab-message',
  template: require('./tracker.workflow.transition.tab.message.component.html'),
})
export class TrackerAdminWorkflowTransitionTabMessageComponent {
  @Input() toFieldElement: any;

  constructor() {}
}
